import useSWR from "swr";
import { MeContext } from "@/types";
import { getMe } from "@/services/storageManager";

/**
 * Resolves the current user's application role (member | supervisor | superadmin)
 * and supervised groups from the backend. Shared via SWR so multiple components
 * (sidebar, route guards, pages) reuse a single request.
 */
export function useMe() {
  const { data, error, isLoading } = useSWR<MeContext>("/me", getMe, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  return {
    me: data,
    role: data?.role ?? "member",
    supervisedGroupIds: data?.supervisedGroupIds ?? [],
    isSupervisor: data?.role === "supervisor",
    isSuperadmin: data?.role === "superadmin",
    isLoading,
    isError: error,
  };
}
